import { parseUsableUserId } from '@multiplatform-apps/service-trips';

import { paths } from './paths';

export const userDetailsPath = (id: string | null | undefined): string | undefined => {
  const userId = parseUsableUserId(id);
  if (!userId) return undefined;

  return `${paths.users.root}/${paths.users.details}`.replace(':userId', userId);
};
